import type { Partner } from 'src/types';

import type { DataState } from './hooks/useIntegrationPartners';

export const chooseConnectedPartners = (
  partners: DataState<Partner[]>,
): DataState<Partner[]> => {
  if (partners.state === 'data') {
    return {
      state: 'data',
      data: partners.data.filter(({ status }) => status === 'Published'),
    };
  }

  return partners;
};
